import {Component} from '@angular/core';

@Component({
  selector: 'app-wrapper-profile',
  templateUrl: './wrapper-profile.component.html',
})
export class WrapperProfileComponent {}
